import { OAuthCallback } from '@client/components/OAuthCallback';
import { postGoogleAuthCodeByAdvisorIdRequest } from '@client/model/sessionModel';
import { useMemo } from 'react';

export function GoogleOAuthCallback() {
  const providerConfig = useMemo(
    () => ({
      provider: 'google' as OAuthProvider,
      title: 'Gmail Connected Successfully!',
      dispatchAction: postGoogleAuthCodeByAdvisorIdRequest,
    }),
    [],
  );

  return <OAuthCallback providerConfig={providerConfig} />;
}
